import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

interface JourneyStep {
  page: string;
  nextPages: { page: string; count: number }[];
}

interface UserJourneyFlowProps {
  journeyData: JourneyStep[];
}

export function UserJourneyFlow({ journeyData }: UserJourneyFlowProps) {
  if (journeyData.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>User Journey Flow</CardTitle>
          <CardDescription>Page navigation patterns</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-center py-8">
            Not enough data to show user journeys
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>User Journey Flow</CardTitle>
        <CardDescription>Most common navigation paths through your site</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {journeyData.slice(0, 5).map((step, idx) => (
            <div key={idx} className="space-y-2">
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="font-mono text-xs">
                  {step.page}
                </Badge>
                {step.nextPages.length > 0 && (
                  <span className="text-muted-foreground text-xs">leads to:</span>
                )}
              </div>
              
              {step.nextPages.length > 0 && (
                <div className="ml-8 space-y-2">
                  {step.nextPages.slice(0, 3).map((next, i) => (
                    <div key={i} className="flex items-center gap-2 text-sm">
                      <ArrowRight className="h-4 w-4 text-muted-foreground" />
                      <Badge variant="secondary" className="font-mono text-xs">
                        {next.page}
                      </Badge>
                      <span className="text-muted-foreground text-xs">
                        ({next.count} time{next.count > 1 ? 's' : ''})
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
